module.exports = __webpack_public_path__ + "static/img/1.397d084.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.jpg
// module id = tGse
// module chunks = 64